import Api from "../../utils/Api.jsx";
import Button from "../componentes/Button.jsx";
import React from "react";
import Row from "../componentes/Row.jsx";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

import LabeledInput from "../componentes/LabeledInput.jsx";
import TelaLogout from "../componentes/TelaLogout.jsx";


class RecuperarSenha extends React.Component {
    constructor() {
        super();
        this.state = {
            senha: "",
            confirmarSenha: "",
            tipoSenha: {
                nova: true,
                confirmar: true,
            },
            status_validacao: {
                tamanho: false,
                letra: false,
                especial: false,
            },
        };

        this.setInputNovaRef = (element) => {
            this.inputNovaRef = element;

        };
        this.setInputConfirmarRef = (element) => {
            this.inputConfirmarRef = element;

        };

        // Padrão do LTE:
        document.body.className = "hold-transition login-page";
    }

    componentDidMount() {
        const token = this.pegaTokenGravadoUrl();
        if (!token) {
            this.props.history.push("/"); 
        }
       
    }


    pegaTokenGravadoUrl() {
        const url = window.location.href.split("?");
        return url[1];
    }


    validarSenha = (senha) => {
        const status_validacao = {
            tamanho: senha.length >= 8,
            letra: /[A-Za-z]/.test(senha),
            especial: /[^A-Za-z0-9]/.test(senha),
        };
        this.setState({ senha: senha, status_validacao });
    };

    getColor = (status) => {
        return status ? 'green' : 'red';
    };

    toggleSenhaVisibilidade = (field) => {
        this.setState((prevState) => ({
            tipoSenha: {
                ...prevState.tipoSenha,
                [field]: !prevState.tipoSenha[field],
            },
        }));
    };

    checarValidacoes = () => {

        const { senha, status_validacao, confirmarSenha } = this.state;
        const erros = [];
        if (!status_validacao.tamanho) erros.push('Senha muito pequena.');
        if (!status_validacao.letra) erros.push('Não contém letra.');
        if (!status_validacao.especial) erros.push('Não contém caractere especial.');
        if (senha.trim() !== confirmarSenha.trim()) erros.push('As senhas não coincidem.');

        if (erros.length > 0) {
            toastr.error('Erro(s) de Validação:', erros.join(' '));
            return false;
        } else {
            return true
        }
    }

    async alterarSenha() {

        if (!this.checarValidacoes()) {
            return;
        }

        const token = this.pegaTokenGravadoUrl();

        try {
            const ret = await Api.trocarSenha(
                this.state.senha,
                token
            );
            if (ret && ret.status) {
                this.setState({
                    senha: '',
                    confirmarSenha: '',
                    status_validacao: {
                        tamanho: false,
                        letra: false,
                        especial: false,
                    },
                }),

                    this.props.history.push("/");
                toastr.success("Troca de senha realizada com sucesso");

            } else if (ret && ret.message) {
                toastr.error("Erro", ret.message);
            } else {
                toastr.error("Erro inesperado ao trocar senha");
            }
        } catch (ex) {
            toastr.error(
                "Erro!",
                "Rode o atualizador pelo console, provavelmente há um erro!"
            );
        }
    }


    renderBody() {
        return (
            <div className="login-box-body">
                <div className="stripe" />
                <div>
                    <div className="form-group has-feedback " style={{ position: "relative", width: "100%" }}>
                        <LabeledInput
                            label="Nova Senha:"
                            placeholder="Digite a nova senha"
                            uppercase="false"
                            value={this.state.senha}
                            type={this.state.tipoSenha.nova ? 'password' : 'input'}
                            inputRef={this.setInputNovaRef}
                            onChange={(e) => this.validarSenha(e.target.value)}
                            name={this.state.uuid}
                            autoComplete
                            style={{
                                height: '50px',
                                fontSize: '18px',
                                marginBottom: '15px'
                            }}
                            labelStyle={{
                                color: 'black',
                                fontSize: '16px',
                                fontWeight: 'bold',
                            }}
                        />
                        <i
                            className={`fa ${this.state.tipoSenha.nova ? "fa-eye" : "fa-eye-slash"}`}
                            onClick={() => this.toggleSenhaVisibilidade('nova')}
                            style={{
                                position: "absolute",
                                right: "25px",
                                top: "29%",
                                transform: "translateY(-50%)",
                                fontSize: "18px",
                                cursor: "pointer",
                            }}
                        />
                        <LabeledInput
                            label="Confirme a Senha:"
                            placeholder="Confirme a nova senha"
                            uppercase="false"
                            value={this.state.confirmarSenha}
                            type={this.state.tipoSenha.confirmar ? 'password' : 'input'}
                            inputRef={this.setInputConfirmarRef}
                            onChange={(e) => this.setState({ confirmarSenha: e.target.value })}
                            name={this.state.uuid}
                            autoComplete
                            style={{
                                height: '50px',
                                fontSize: '18px',
                            }}
                            labelStyle={{
                                color: 'black',
                                fontSize: '16px',
                                fontWeight: 'bold',
                            }}
                        />
                        <i
                            className={`fa ${this.state.tipoSenha.confirmar ? "fa-eye" : "fa-eye-slash"}`}
                            onClick={() => this.toggleSenhaVisibilidade('confirmar')}
                            style={{
                                position: "absolute",
                                right: "25px",
                                top: "84%",
                                transform: "translateY(-50%)",
                                fontSize: "18px",
                                cursor: "pointer",
                            }}
                        />
                    </div>

                    <p className="mt-10" style={{ fontSize: '16.5px' }}>As senhas devem atender aos seguintes critérios:</p>
                    <ul style={{ fontSize: '16.5px' }}>
                        <li style={{ color: this.getColor(this.state.status_validacao.tamanho) }}>
                            Deve conter pelo menos 8 caracteres
                        </li>
                        <li style={{ color: this.getColor(this.state.status_validacao.letra) }}>
                            Deve conter uma letra
                        </li>
                        <li style={{ color: this.getColor(this.state.status_validacao.especial) }}>
                            Deve conter um caractere especial
                        </li>
                        <li
                            style={{
                                color: this.getColor(
                                    this.state.senha.trim() === this.state.confirmarSenha.trim() &&
                                    this.state.senha
                                ),
                            }}
                        >
                            As senhas são iguais
                        </li>
                    </ul>

                    <Row>
                        <div className="col-sm-2 col-sm-offset-4 text-center"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "20px",
                                width: "35%",
                            }}>

                            <Button
                                icon="fa-unlock"
                                label="Alterar"
                                className="btn-primary"
                                onClick={this.alterarSenha.bind(this)}
                                style={{
                                    width: '150px',
                                    height: '45px',
                                    fontSize: '18px',
                                    padding: '10px',
                                }}
                            />
                        </div>
                    </Row>
                </div>
            </div>

        );
    }
    render() {

        return (
            <div>
                <TelaLogout
                    renderBody={this.renderBody.bind(this)}
                    ref={e => this.recuperarSenha = e}
                    focusFieldRef={() => {
                        if (this.inputNovaRef) {
                            this.inputNovaRef.focus();
                        }
                    }}

                />
            </div>


        );
    }
}

export default connect(
    (state) => ({
        socket: state.socket,
    }),
    (dispatch) => ({
        dispatch,
    })
)(RecuperarSenha);

// export default connect(null, (dispatch) => ({
//   dispatch,
// }))(Login);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/RecuperarSenha.jsx